import {endOfDay, isValid, parseISO} from 'date-fns';
import {match, Pattern} from 'ts-pattern';

import {isNotNil} from 'ramda';

import type {TaskResponseBody} from '@dms/api/core';

import type {InterestPlannedActivity} from '@prompt-bridge/shared/ai-assistant-core';

const toDateOnlyTaskDueAt = (dueDate: string | null) =>
  match(dueDate)
    .returnType<string | null>()
    .with(Pattern.nullish, () => null)
    .otherwise((date) => {
      const parsedDate = parseISO(date);

      return match(isValid(parsedDate))
        .with(true, () => endOfDay(parsedDate).toISOString())
        .otherwise(() => null);
    });

export const toTaskInterestPlannedActivity = (task: TaskResponseBody): InterestPlannedActivity => ({
  id: task.id,
  kind: 'task',
  dueAt: task.dueTo ?? task.dueFrom ?? toDateOnlyTaskDueAt(task.dueDate),
  completed: task.state === 'DONE' || isNotNil(task.finishedAt),
});
